export const en = {
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    retry: 'Retry',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    confirm: 'Confirm',
    back: 'Back',
    close: 'Close',
    search: 'Search',
    noData: 'No data',
  },
  tabs: {
    home: 'Home',
    settings: 'Settings',
    profile: 'Profile',
  },
  settings: {
    title: 'Settings',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeSystem: 'System',
    language: 'Language',
    version: 'Version',
    about: 'About',
  },
  home: {
    title: 'Home',
    welcome: 'Welcome',
    description: 'Get started by editing the features.',
  },
  admin: {
    nav: {
      dashboard: 'Dashboard',
      users: 'Users',
      posts: 'Posts',
      settings: 'Settings',
      activity: 'Activity',
      notifications: 'Notifications',
      menu: 'Menu',
      collapse: 'Collapse',
    },
    header: { title: 'Admin Panel' },
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Overview of your workspace.',
      greeting: 'Welcome back, {{name}}',
      todayOverview: "Here's what's happening in your workspace today.",
      stats: {
        totalUsers: 'Total Users',
        activeProjects: 'Active Projects',
        tasksCompleted: 'Tasks Completed',
        pendingReviews: 'Pending Reviews',
      },
      recentActivity: 'Recent Activity',
      viewAll: 'View all',
      vsLastMonth: 'vs last month',
      noActivity: 'No recent activity to display.',
      systemHealth: 'System Health',
      uptime: 'Uptime',
      responseTime: 'Avg. Response',
      errorRate: 'Error Rate',
      allOperational: 'All systems operational',
    },
    users: {
      title: 'Users',
      subtitle: 'Manage user accounts and permissions.',
      addUser: 'Add User',
      search: 'Search users...',
      totalMembers: 'Total Members',
      activeNow: 'Active Now',
      admins: 'Admins',
      activeRate: '{{rate}}% active rate',
      noResults: 'No members found',
      noResultsHint: 'Try adjusting your search query',
      filterAll: 'All',
      table: {
        name: 'Name',
        email: 'Email',
        role: 'Role',
        status: 'Status',
        department: 'Department',
        lastLogin: 'Last Login',
      },
      form: {
        createTitle: 'Add User',
        editTitle: 'Edit User',
        nameLabel: 'Name',
        namePlaceholder: 'Full name',
        emailLabel: 'Email',
        emailPlaceholder: 'email@example.com',
        roleLabel: 'Role',
        rolePlaceholder: 'Select a role',
        statusLabel: 'Active',
        statusHint: 'Inactive users cannot sign in.',
        save: 'Save',
        saving: 'Saving...',
        cancel: 'Cancel',
        avatar: 'Avatar',
        phone: 'Phone',
        department: 'Department',
        bio: 'Bio',
        joinDate: 'Join Date',
        lastLogin: 'Last Login',
        phonePlaceholder: 'Phone number',
        departmentPlaceholder: 'Department name',
        bioPlaceholder: 'Brief bio...',
      },
      actions: {
        edit: 'Edit',
        delete: 'Delete',
        activate: 'Activate',
        deactivate: 'Deactivate',
        sendMessage: 'Send Message',
        sendPush: 'Send Push',
      },
      bulk: {
        selected: '{{count}} selected',
        message: 'Message',
        push: 'Push',
        delete: 'Delete',
      },
      messageDialog: {
        title: 'Send Message',
        placeholder: 'Write your message...',
        send: 'Send',
      },
      pushDialog: {
        title: 'Send Push Notification',
        recipient: 'To: {{name}}',
        recipientBulk: 'To: {{count}} users',
        titleLabel: 'Title',
        titlePlaceholder: 'Notification title',
        bodyLabel: 'Body',
        bodyPlaceholder: 'Notification body...',
        send: 'Send Push',
      },
      bulkDeleteConfirm: {
        title: 'Delete {{count}} users',
        description:
          'This will permanently remove all selected users and revoke their access.',
      },
      deleteConfirm: {
        title: 'Delete user',
        description:
          'This will permanently remove the user and revoke all access.',
        confirm: 'Delete',
        cancel: 'Cancel',
      },
      pagination: {
        showing: 'Showing {{from}}-{{to}} of {{total}}',
      },
      toast: {
        deleted: 'User has been deleted',
        activated: 'User activated',
        deactivated: 'User deactivated',
        messageSent: 'Message sent to {{name}}',
        pushSent: 'Push notification sent to {{name}}',
        bulkDeleted: '{{count}} users deleted',
        bulkMessageSent: 'Message sent to {{count}} users',
        bulkPushSent: 'Push sent to {{count}} users',
      },
      roles: {
        admin: 'Admin',
        member: 'Member',
        viewer: 'Viewer',
      },
    },
    posts: {
      title: 'Posts',
      subtitle: 'Create and manage board content.',
      addPost: 'New Post',
      search: 'Search posts...',
      totalPosts: 'Total',
      published: 'Published',
      draft: 'Draft',
      all: 'All',
      allCategories: 'All Categories',
      noResults: 'No posts found',
      noResultsHint: 'Try adjusting your search or filter',
      table: {
        title: 'Title',
        author: 'Author',
        category: 'Category',
        status: 'Status',
        date: 'Date',
      },
      form: {
        createTitle: 'New Post',
        editTitle: 'Edit Post',
        titleLabel: 'Title',
        titlePlaceholder: 'Enter post title',
        contentLabel: 'Content',
        contentPlaceholder: 'Write your post content here...',
        categoryLabel: 'Category',
        categoryPlaceholder: 'Select a category',
        statusLabel: 'Publish immediately',
        statusHint: 'Draft posts are only visible to admins.',
        save: 'Save',
        saving: 'Saving...',
        cancel: 'Cancel',
        saved: 'Post saved',
        deleted: 'Post deleted',
        coverImage: 'Cover Image',
        coverImageHint: 'Drag & drop or click to upload',
        removeCoverImage: 'Remove',
        tags: 'Tags',
        tagsPlaceholder: 'Add a tag and press Enter',
        excerpt: 'Excerpt',
        excerptPlaceholder: 'Brief summary for preview...',
      },
      actions: {
        edit: 'Edit',
        delete: 'Delete',
        publish: 'Publish',
        unpublish: 'Unpublish',
        sendPush: 'Send Push',
        copyLink: 'Copy Link',
      },
      bulk: {
        selected: '{{count}} selected',
        publish: 'Publish',
        unpublish: 'Unpublish',
        push: 'Push',
        delete: 'Delete',
      },
      pushDialog: {
        title: 'Send Push Notification',
        recipient: 'Post: {{name}}',
        recipientBulk: 'To: {{count}} posts',
        titleLabel: 'Title',
        titlePlaceholder: 'Notification title',
        bodyLabel: 'Body',
        bodyPlaceholder: 'Notification body...',
        send: 'Send Push',
      },
      bulkDeleteConfirm: {
        title: 'Delete {{count}} posts',
        description:
          'This will permanently remove all selected posts. This cannot be undone.',
      },
      toast: {
        deleted: 'Post deleted',
        published: 'Post published',
        unpublished: 'Post unpublished',
        pushSent: 'Push sent for "{{title}}"',
        linkCopied: 'Link copied to clipboard',
        bulkDeleted: '{{count}} posts deleted',
        bulkPublished: '{{count}} posts published',
        bulkUnpublished: '{{count}} posts unpublished',
        bulkPushSent: 'Push sent for {{count}} posts',
      },
      deleteConfirm: {
        title: 'Delete post',
        description:
          'This action cannot be undone. The post will be permanently removed.',
        confirm: 'Delete',
        cancel: 'Cancel',
      },
      pagination: {
        showing: 'Showing {{from}}-{{to}} of {{total}}',
      },
      categories: {
        announcement: 'Announcement',
        guide: 'Guide',
        internal: 'Internal',
        report: 'Report',
      },
    },
    settings: {
      title: 'Settings',
      subtitle: 'Manage your account and app preferences.',
      profile: {
        title: 'Profile',
        nameLabel: 'Name',
        emailLabel: 'Email',
        roleLabel: 'Role',
        save: 'Save Changes',
      },
      app: {
        title: 'App Settings',
        siteNameLabel: 'Site Name',
        languageLabel: 'Default Language',
        timezoneLabel: 'Timezone',
      },
      notifications: {
        title: 'Notification Preferences',
        emailLabel: 'Email Notifications',
        emailHint: 'Receive updates via email.',
        pushLabel: 'Push Notifications',
        pushHint: 'Receive in-app push alerts.',
      },
      toast: {
        saved: 'Settings saved',
      },
    },
    activity: {
      title: 'Activity Log',
      subtitle: 'Track all admin actions and changes.',
      search: 'Search activity...',
      filterAll: 'All',
      filterUser: 'Users',
      filterPost: 'Posts',
      filterSystem: 'System',
      noResults: 'No activity found',
      noResultsHint: 'Try adjusting your search or filter.',
      table: {
        user: 'User',
        action: 'Action',
        target: 'Target',
        date: 'Date',
        ip: 'IP',
      },
      actions: {
        created_user: 'Created user',
        deleted_user: 'Deleted user',
        updated_user: 'Updated user',
        created_post: 'Created post',
        deleted_post: 'Deleted post',
        published_post: 'Published post',
        updated_settings: 'Updated settings',
        sent_push: 'Sent push notification',
        login: 'Logged in',
        export: 'Exported data',
      },
    },
    notifications: {
      title: 'Notifications',
      subtitle: 'Manage push notification history and templates.',
      tabs: {
        history: 'History',
        templates: 'Templates',
      },
      search: 'Search notifications...',
      newNotification: 'New Notification',
      newTemplate: 'New Template',
      noResults: 'No notifications found',
      noResultsHint: 'Send your first push notification.',
      noTemplates: 'No templates yet',
      noTemplatesHint: 'Create a reusable notification template.',
      stats: {
        totalSent: 'Total Sent',
        thisWeek: 'This Week',
        openRate: 'Open Rate',
      },
      table: {
        title: 'Title',
        body: 'Body',
        recipients: 'Recipients',
        status: 'Status',
        date: 'Sent At',
      },
      status: {
        sent: 'Sent',
        scheduled: 'Scheduled',
        failed: 'Failed',
      },
      sendDialog: {
        title: 'Send Notification',
        titleLabel: 'Title',
        titlePlaceholder: 'Notification title',
        bodyLabel: 'Body',
        bodyPlaceholder: 'Notification body...',
        targetLabel: 'Target Audience',
        targetAll: 'All Users',
        targetAdmins: 'Admins Only',
        targetMembers: 'Members Only',
        send: 'Send Now',
      },
      templateDialog: {
        title: 'Save Template',
        nameLabel: 'Template Name',
        namePlaceholder: 'e.g. Weekly Update',
        titleLabel: 'Notification Title',
        titlePlaceholder: 'Title template',
        bodyLabel: 'Notification Body',
        bodyPlaceholder: 'Body template...',
        save: 'Save Template',
      },
      toast: {
        sent: 'Notification sent to {{count}} users',
        templateSaved: 'Template saved',
        templateDeleted: 'Template deleted',
      },
      actions: {
        useTemplate: 'Use',
        deleteTemplate: 'Delete',
      },
    },
  },
  landing: {
    nav: {
      goldPrice: 'Gold Price',
      about: 'Business',
      reservation: 'Visit',
      report: 'Report',
    },
    hero: {
      badge: 'Physical Asset Specialists',
      title: 'Redefining the standard',
      titleHighlight: 'of real asset trading.',
      subtitle:
        'Taebum Precious Metals connects the value of precious metals and industrial materials more transparently, powered by refining-based appraisal technology and real-time market data.',
      keyMessage: 'We buy directly, and supply directly.',
      ctaPrimary: 'Check Live Prices',
      ctaSecondary: 'Get Asset Appraisal',
    },
    about: {
      title: 'Built on traditional trust,',
      titleHighlight: 'powered by digital innovation.',
      description:
        'Taebum Precious Metals is a physical asset specialist that establishes transparent trading standards and evaluates customer assets with the most reasonable criteria.',
      descriptionSub:
        'Based on years of accumulated appraisal expertise and market analysis, we go beyond simple transactions to build a structure that provides accurate standards and trust.',
      points: {
        valuation: {
          title: 'Honest Valuation',
          description:
            'We accurately evaluate purity and weight through rigorous assay systems.',
        },
        realtime: {
          title: 'Real-time Pricing',
          description:
            'We provide market-based trading standards reflecting domestic and international prices.',
        },
        customized: {
          title: 'Customized Asset Management',
          description:
            'We offer optimized trading environments for both individuals and businesses.',
        },
      },
      buyRequest: 'Request Purchase',
    },
    differentiators: {
      title: 'Less distribution,',
      titleHighlight: 'higher standards.',
      subtitle: 'This is how we differ',
      items: {
        directPurchase: {
          title: 'Direct Purchase Model',
          description:
            'We offer higher purchase prices by eliminating intermediaries.',
        },
        refiningEvaluation: {
          title: 'Refining-based Evaluation',
          description:
            'We assess asset value more precisely for gold, silver, palladium, copper and more.',
        },
        directSupply: {
          title: 'Direct Supply System',
          description:
            'We connect enterprise clients with reliable raw material supply.',
        },
      },
    },
    businessAreas: {
      title: 'Beyond precious metals,',
      titleHighlight: 'to industrial materials.',
      description:
        'Taebum Precious Metals is expanding beyond simple gold trading to a structure that covers all physical assets.',
      items: {
        purchase:
          'Purchase of pure gold / 18K / 14K / platinum / silver / copper',
        supply: 'Gold bar / Silver bar supply',
        b2b: 'B2B raw material supply for enterprises',
        store: 'Direct store operations',
        online: 'Online platform business',
        production: 'Gold bar / Jewelry product manufacturing',
      },
    },
    platform: {
      subtitle: 'More transparent value, more solid transactions',
      description:
        'Going beyond the closed and complex precious metals trading market, Taebum is preparing a new digital platform so that anyone can trade with clearer information and a more trustworthy structure.',
      bannerTitle: 'A platform for standards, coming soon',
      benefitsTitle: 'The platform changes the market',
      benefits: {
        distribution: {
          title: 'Shortened Distribution',
          description:
            'By eliminating multi-layer distribution and enabling direct trading, sellers get higher prices and buyers get lower prices.',
        },
        data: {
          title: 'Data-driven Pricing',
          description:
            'By publishing real-time prices and trading data, anyone can trade based on accurate market standards.',
        },
        trust: {
          title: 'Verified Safe Trading',
          description:
            "Based on Taebum's appraisal capabilities, we guarantee the quality and trust of every transaction.",
        },
      },
    },
    cta: {
      title: 'Check the value of your assets now.',
      ctaPrimary: 'View Live Prices',
      ctaSecondary: 'Request Purchase Consultation',
      step1: 'Online Purchase Request',
      step2: 'Store Visit & Appraisal',
      step3: 'Asset Growth',
    },
    goldPrice: {
      title: 'Live Gold Price',
      prevDay: 'vs Previous',
      changeRate: 'Change',
      international: 'International',
      domestic: 'Domestic',
      taebum: 'Taebum (Buy)',
      sell: 'Sell (Purchase)',
    },
    report: {
      subtitle: 'Issues at a Glance',
      title: 'Taebum Report',
      viewAll: 'View All',
      readMore: 'Read',
      backToList: 'Back to list',
      otherReports: 'Other Reports',
      allCategory: 'All',
    },
    purchase: {
      title: 'Purchase Consultation',
      description:
        'Please fill in the information below and our team will contact you shortly.',
      name: 'Name',
      namePlaceholder: 'John Doe',
      phone: 'Phone',
      phonePlaceholder: '010-0000-0000',
      item: 'Item',
      itemPlaceholder: 'Select an item',
      items: {
        pureGold: 'Pure Gold (24K)',
        gold18k: '18K Gold',
        gold14k: '14K Gold',
        silver: 'Silver',
        platinum: 'Platinum',
        other: 'Other',
      },
      weight: 'Weight (g)',
      weightPlaceholder: 'e.g. 37.5',
      memo: 'Memo',
      memoPlaceholder: 'Any additional requests',
      submit: 'Submit',
      preparing:
        'Online submission is currently being prepared.\nPlease contact our store directly.',
      purchaseOnlyLabel: 'Buy',
    },
    footer: {
      companyName: 'Taebum Precious Metals',
      copyright: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
  },
};
